import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ButtonModule} from '@aztrix/components/button';
import {IconsModule} from '@aztrix/icons';

import {ChipComponent} from './chip.component';
import {ChipDirective} from './chip.directive';

@NgModule({
  declarations: [ChipDirective, ChipComponent],
  imports: [CommonModule, IconsModule, ButtonModule],
  exports: [ChipDirective, ChipComponent],
})
export class ChipModule {}
